/** @format */

import React from "react";
import { Navigate } from "react-router-dom";
import { useOktaAuth } from "@okta/okta-react";
import SignInWidget from "./SignInWidget";

const Login = (props) => {
  const { oktaAuth, authState } = useOktaAuth();

  const onSuccess = (res) => {
    oktaAuth.handleLoginRedirect(res.tokens);
  };

  const onError = (err) => {};

  if (!authState) {
    return null;
  }

  return authState.isAuthenticated ? (
    <Navigate to={{ pathname: "/" }} />
  ) : (
    <SignInWidget onSuccess={onSuccess} onError={onError} />
  );
};

export default Login;
